/** Base inset for level-0 rows in the sidebar. */
export const MENU_PADDING_BASE_REM = 0.75;

/** Extra inset per nesting level (icon column + gap). */
export const MENU_PADDING_LEVEL_REM = 2.25;

export function menuPaddingLeft(level = 0): string {
  return `${MENU_PADDING_BASE_REM + level * MENU_PADDING_LEVEL_REM}rem`;
}
